import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import { PagingState, EditingState, CustomPaging, FilteringState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, TableEditRow, TableEditColumn, TableFilterRow, TableColumnVisibility } from "@devexpress/dx-react-grid-material-ui";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { QueryString, Update, Remove, ExportXlsx, APPNAME_RELATORIOPERSONALIZADO } from "../utils/react_grid_utils";
import { editColumnMessages } from "../utils/react_grid_edit_command_localization";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import { NumberTypeProvider } from './../utils/react_grid_number_column';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Divider from '@mui/material/Divider';
import TextField from "@material-ui/core/TextField";
import CookieService from "../../services/CookieService";
import { Alert, InputAdornment, Grid as MIUGrid, Snackbar, Tooltip} from '@mui/material'
import Header from "../Header";
import Import from "../utils/import";

let user = CookieService.get("user");
const emailAdmin = process.env.REACT_APP_EMAIL_ADMIN;
const getRowId = (row) => row.id;
const api_resource = "relatorio-personalizado/ticket-medio";

export default function TicketMedioTable() {
  const alert = useAlert();

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(20);
  const [totalItens, setTotalItens] = useState(20);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [filteringStateColumnExtensions] = useState([
    { columnName: "ticket_medio_vigente", filteringEnabled: false },
    { columnName: "inicio_vigente", filteringEnabled: false },
    { columnName: "fim_vigente", filteringEnabled: false }
  ]);

  const [tableColumnExtensions] = useState([
    { columnName: "id", width: 40 },
    { columnName: "codigo_especialidade", width: "15%" },
    { columnName: "descricao_especialidade", width: "30%" },
    { columnName: "tipo_recebimento", width: "25%" },
    { columnName: "ticket_medio_vigente", width: "10%" },
    { columnName: "inicio_vigente", width: "10%" },
    { columnName: "fim_vigente", width: "10%" },
  ]);

  var columns = [
    { name: "id", title: "ID" },
    { name: "codigo_especialidade", title: "Código Especialidade" },
    { name: "descricao_especialidade", title: "Descrição da Especialidade" },
    { name: "tipo_recebimento", title: "Tipo de Recebimento" },
    { name: "ticket_medio_vigente", title: "Ticket Médio" },
    { name: "inicio_vigente", title: "Início Vigência" },
    { name: "fim_vigente", title: "Fim Vigência" },
  ];

  const [defaultHiddenColumnNames] = useState(["id"]);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [filtersApi, setFiltersApi] = useState([]);
  //
  const [id, setId] = useState(0)
  const [codigoEspecialidade, setCodigoEspecialidade] = useState('')
  const [descricaoEspecialidade, setDescricaoEspecialidade] = useState('')
  const [tipoRecebimento, setTipoRecebimento] = useState('')
  const [ticketValues, setTicketValues] = useState([])
  // Vigentes
  const [ticketMedio, setTicketMedio] = useState('')
  const [inicio, setInicio] = useState()
  const [fim, setFim] = useState()
  //
  const userCanEdit = () => {
    if (authenticatedUserContext.allow_edit('Relatório Personalizado'))
      return true
    return false
  };
  //
  const [creatingVigencia, setCreatingVigencia] = useState(false)
  // Modal Delete
  const [openDelete, setOpenDelete] = useState(false);

  const handleCloseDelete = () => {
    setOpenDelete(false);
  }

  // Modal Create
  const [openCreate, setOpenCreate] = useState(false);
  const [error, setError] = useState(false)

  const handleClickOpenCreate = () => {
    setError(false)
    setId(0)
    setCodigoEspecialidade('')
    setDescricaoEspecialidade('')
    setTipoRecebimento('')
    setTicketValues([])

    setTicketMedio('')
    setInicio()
    setFim()

    setOpenCreate(true);
  };

  const handleCloseCreate = () => {
    setOpenCreate(false);
  };

  // Modal
  const [selectedRow, setSelectedRow] = useState(null); 
  const [open, setOpen] = useState(false); 

  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function formatToBrazilianCurrency(value) {
    if (value == null || isNaN(value)) return "0,00"; // Trata valores nulos ou inválidos
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    }).format(value);
  }

  function get(page, filters) {
    const queryString = QueryString(page, pageSize, filters);
    http.get(api_resource + queryString).then(
      (response) => {
        const formattedData = response.data.data.map((item) => ({
          ...item,
          ticket_medio_vigente: formatToBrazilianCurrency(item.ticket_values[0].ticket_medio)
          // inicio: formatDateBR(item.inicio),
          // fim: item.fim ? formatDateBR(item.fim) : 'Atual',
        }));
  
        setRows(formattedData);
        setTotalItens(parseInt(response.data.total, 10));
      },
      (error) => {
        console.error(error);
      }
    );
  }

  function encerrarVigencia() {
    const item = {
      type: 'end',
      id: id,
      codigo_especialidade: codigoEspecialidade,
      descricao_especialidade: descricaoEspecialidade,
      tipo_recebimento: tipoRecebimento,
      inicio: inicio,
      fim: fim,
      ticket_medio: ticketMedio,
      values: ticketValues,
      user: user
    }
    Update(api_resource, item, alert).then((response) => {
      setOpen(false)
      get(pageIndex, [])
    })
  }

  function novaVigencia() {
    setInicio(new Date().toISOString().split('T')[0])
    setFim('')
    setTicketMedio(ticketMedio ? ticketMedio+1 : 0)
    setCreatingVigencia(true)
  }

  function commitNovaVigencia(){
    const item = {
      type: 'create',
      id: id,
      codigo_especialidade: codigoEspecialidade,
      descricao_especialidade: descricaoEspecialidade,
      tipo_recebimento: tipoRecebimento,
      inicio: inicio,
      fim: fim,
      ticket_medio: ticketMedio,
      values: ticketValues,
      user: user
    }
    Update(api_resource, item, alert).then((response) => {
      setOpen(false)
      get(pageIndex, [])
    })
  }

  function commitNovoTicketMedio(){
    const item = {
      codigo_especialidade: codigoEspecialidade,
      descricao_especialidade: descricaoEspecialidade,
      tipo_recebimento: tipoRecebimento,
      inicio: inicio,
      fim: fim,
      ticket_medio: ticketMedio,
      user: user
    }
    Create(api_resource, item)
      .then(() => {
        setError(false)
        setOpenCreate(false)
        get(pageIndex, [])
      })
      .catch((error) => {
        setError(true)
        console.error("Erro ao criar:", error);
      });
  }

  function commitDelete(){
    const item = {
      id: id,
      user: user
    }
    Remove(api_resource, item).then((response) => {
      setOpenDelete(false)
      setOpen(false)
      setOpenCreate(false)
      get(pageIndex, [])
    })
  }

  const Create = (api_resource, data) => {
    return new Promise((resolve, reject) => {
      http.post(api_resource, data).then(
        (response) => {
          alert.success("Ticket Médio criado com sucesso!");
          resolve(response);
        },
        (error) => {
          alert.show(error.messages[0].message, { type: "error" });
          reject(error);
        }
      );
    });
  };

  const Remove = (api_resource, data) => {
    return new Promise((resolve, reject) => {
      http.delete(`${api_resource}/${data.id}/${data.user.id}`).then(
        (response) => {
          alert.success("Item removido com sucesso!");
          resolve(response);
        },
        (error) => {
          alert.show(error.messages[0].message,  { type: "error" });
          reject(error);
        }
      );
    });
  };

  useEffect(() => {
    get(0, []);
  }, []);

  useEffect(() => {
    if (selectedRow){
      setId(selectedRow.id ?? 0)
      setCodigoEspecialidade(selectedRow.codigo_especialidade ?? '')
      setDescricaoEspecialidade(selectedRow.descricao_especialidade ?? '')
      setTipoRecebimento(selectedRow.tipo_recebimento ?? '')
      setTicketValues(selectedRow.ticket_values ?? [])
      //Vigentes
      setTicketMedio(selectedRow?.ticket_values[0]?.ticket_medio ?? '')
      setInicio(selectedRow?.ticket_values[0]?.inicio ?? null)
      setFim(selectedRow?.ticket_values[0]?.fim ?? null)
      
      //
      setCreatingVigencia(false)
    }
  }, [selectedRow])

  const [timer, setTimer] = useState(null);

  function handleFilters(filters) {
    clearTimeout(timer);
    setFiltersApi(filters);

    setTimer(
      setTimeout(function () {
        get(pageIndex, filters);
      }, 1000)
    );
  }

  function handlePage(page, totalRows) {
    setPageIndex(page);
    get(page, filtersApi);
  }

  const TableRowComponent = ({ row, ...restProps }) => (
    <TableRow
       {...restProps}
       style={{ cursor: "pointer" }} // Cursor to indicate clickable row
       onClick={() => handleClickOpen(row)} // Event handler to open modal
    />
 );


  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header/>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2><i className="fa fa-ticket"></i> Ticket Médio</h2>
          </div>
          <div className="col-lg-2" style={{ display: "flex", justifyContent: 'flex-end' }}>
            <Import 
              api_resource={api_resource} 
              alert={alert} 
              appname={APPNAME_RELATORIOPERSONALIZADO} 
              excluir={false} 
              onFinish={() => {
                get(pageIndex, []);
              }} 
            />
            <button 
              className="btn btn-primary btn-sm" 
              style={{ marginTop: "20px", marginRight:"10px", marginLeft:"10px"}} 
              type="button" 
              onClick={() => ExportXlsx(api_resource, alert)}
            >
              Exportar
            </button>
            <button 
              disabled={!userCanEdit()} 
              className="btn btn-success btn-sm" 
              style={{ marginTop: "20px" }} 
              type="button" 
              onClick={() => handleClickOpenCreate() }
            >
              Criar novo
            </button>
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox ">
                <div className="ibox-content">
                  <Grid rows={rows} columns={columns} getRowId={getRowId}>
                    <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={handlePage} />
                    {/* <EditingState editingRowIds={editingRowIds} onEditingRowIdsChange={setEditingRowIds} rowChanges={rowChanges} onRowChangesChange={setRowChanges} addedRows={addedRows} onAddedRowsChange={changeAddedRows} onCommitChanges={commitChanges} /> */}
                    <FilteringState onFiltersChange={handleFilters} columnExtensions={filteringStateColumnExtensions}/>
                    <Table columnExtensions={tableColumnExtensions}  rowComponent={TableRowComponent}/>
                    <NumberTypeProvider for={["ticket_medio"]} />
                    <TableHeaderRow />
                    <TableColumnVisibility defaultHiddenColumnNames={defaultHiddenColumnNames} />
                    {/*<TableEditRow />*/}
                    {/* {authenticatedUserContext.allow_edit(APPNAME_RELATORIOPERSONALIZADO) === true ? <TableEditColumn showAddCommand={!addedRows.length} showEditCommand showDeleteCommand messages={editColumnMessages} /> : <></>} */}
                    <CustomPaging totalCount={totalItens} />
                    <PagingPanel />
                    <TableFilterRow />
                  </Grid>

                  <Dialog 
                    open={open} 
                    onClose={handleClose} 
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                          width: '800px', 
                          margin: '0 auto'
                        },
                    }}
                  >
                    <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
                      <span style={{ display: 'inline-block', width: '100%' }}>
                        {descricaoEspecialidade}
                      </span>
                      <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        style={{
                          position: 'absolute',
                          right: 30,
                          top: 20,
                          padding: 0
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <Divider variant="fullWidth" />
                    <DialogContent >
                      <DialogContentText style={{ color: "black" }}>
                        {selectedRow && (
                        <> 
                          {/*<h2 style={{color: '#3f51b5'}}>Ticket Médio</h2>*/}
                          <span>
                              Código especialidade: <b style={{color: '#3f51b5'}}> {codigoEspecialidade} </b>
                              <br />
                              Tipo de recebimento: <b style={{color: '#3f51b5'}}>{tipoRecebimento} </b> 
                          </span>
                        </>
                        )}
                        {/* Vigencia */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ color: '#3f51b5', marginRight: '8px', marginBottom:'8px', marginTop: '8px', fontWeight: 800 }}>Vigência</span>
                          <Divider style={{ flex: 1 }} />
                        </div>
                        <MIUGrid container justifyContent="space-between">
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={!creatingVigencia}
                              fullWidth 
                              type="date"  
                              label="Início"
                              value={inicio}
                              name="inicio_vigencia_atual"
                              InputLabelProps={{
                                shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                              }}
                              inputProps={{
                                min: creatingVigencia ? new Date(ticketValues[0]?.fim).toISOString().split("T")[0] ?? undefined : undefined, // Define a data máxima como hoje
                              }}
                              onChange={(e) => {setInicio(e.target.value)}}
                            />
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={ticketValues[0]?.fim || !userCanEdit()}
                              fullWidth 
                              type="date"
                              label="Fim"
                              value={fim}
                              name="fim_vigencia_atual"
                              InputLabelProps={{
                                shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                              }}
                              inputProps={{
                                min: ticketValues && ticketValues.length > 0 && ticketValues[0].inicio ? new Date(ticketValues[0]?.inicio).toISOString().split("T")[0] : undefined, // Define a data máxima como hoje
                              }}
                              onChange={(e) => {setFim(e.target.value)}}
                            />
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={!creatingVigencia}
                              fullWidth 
                              type="number"  
                              label="Ticket Médio"
                              value={ticketMedio || 0}                
                              name="ticket_medio_atual"
                              InputLabelProps={{
                                shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">{'R$'}</InputAdornment>
                                ),
                              }}
                              onChange={(e) => {setTicketMedio(e.target.value)}}
                            />
                          </MIUGrid>
                        </MIUGrid>
                        <div style={{ 
                          display: 'flex',
                          justifyContent: 'flex-end' }}
                        >
                          {!ticketValues[0]?.fim &&
                            <Button 
                              style={{ marginTop: 12, fontSize: 12, display: 'flex'}} 
                              onClick={encerrarVigencia} 
                              variant="contained" 
                              color="primary"
                              disabled={!fim || !userCanEdit()}
                            >
                              Encerrar Vigência Atual
                            </Button>
                          }
                        
                          {(ticketValues[0]?.fim && !creatingVigencia) &&
                            <Button 
                              style={{marginTop: 12, fontSize: 12, display: 'flex'}} 
                              onClick={novaVigencia} 
                              variant="contained" 
                              color="primary"
                            >
                              Nova Vigência
                            </Button>
                          }
                        </div>

                        {/* Historico */}
                        <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                          <span style={{ color: '#3f51b5', marginRight: '8px', fontWeight: 800 }}>Histórico</span>
                          <Divider style={{ flex: 1 }} />
                        </div>
                        <table style={{ width: '100%', marginTop: 10, borderCollapse: 'collapse', fontSize: '14px' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#3f51b5', color: 'white' }}>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Início Vigência</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Fim Vigência</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Ticket Médio</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ticketValues?.map((item, index) => (
                              <tr key={index}>
                                <td style={{ padding: 8, borderBottom: '1px solid #ddd' }}>{item.inicio_str}</td>
                                <td style={{ padding: 8, borderBottom: '1px solid #ddd' }}>{item.fim_str || 'Atual'}</td>
                                <td style={{ padding: 8, borderBottom: '1px solid #ddd'}}> {formatToBrazilianCurrency(item.ticket_medio)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                      {/* Área para o botão "Deletar" */}
                      <div style={{  marginLeft: 16, display: "flex", flexGrow: 1, justifyContent: "flex-start" }}>
                        <Button 
                          style={{ marginRight: 16 }} 
                          onClick={() => {setOpenDelete(true)}} 
                          variant="contained" 
                          color="secondary"
                          disabled={!userCanEdit()}
                        >
                          Deletar
                        </Button>
                      </div>

                      {/* Área para os outros botões */}
                      <div style={{ display: "flex", flexGrow: 1, justifyContent: "flex-end" }}>
                        <Button onClick={handleClose} color="primary">
                          Fechar
                        </Button>
                        <Button 
                          style={{ marginRight: 16 }} 
                          onClick={creatingVigencia ? commitNovaVigencia : handleClose} 
                          variant="contained" 
                          color="primary"
                          disabled={!creatingVigencia || !userCanEdit()}
                        >
                          Salvar
                        </Button>
                      </div>
                    </DialogActions>
                  </Dialog>

                  {/* Create */}
                  <Dialog 
                    open={openCreate} 
                    onClose={handleCloseCreate} 
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                          width: '800px', 
                          margin: '0 auto'
                        },
                    }}
                  >
                  <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
                    <span style={{ display: 'inline-block', width: '100%' }}>
                      Novo Ticket Médio
                    </span>
                    <IconButton
                      edge="end"
                      color="inherit"
                      onClick={handleCloseCreate}
                      aria-label="close"
                      style={{
                        position: 'absolute',
                        right: 30,
                        top: 20,
                        padding: 0
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <Divider variant="fullWidth" />
                  <DialogContent >
                    <DialogContentText style={{ color: "black" }}>
                    <MIUGrid container justifyContent="space-between">
                      <MIUGrid item xs={2} md={2} mt={2}>
                        <TextField
                          variant='outlined'
                          fullWidth  
                          label="Codigo Especialidade"
                          error={error}
                          value={codigoEspecialidade}
                          name="codigo_especialidade"
                          InputLabelProps={{
                            shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                          }}
                          onChange={(e) => {setCodigoEspecialidade(e.target.value)}}
                        />
                      </MIUGrid>
                      <MIUGrid item xs={5} md={5} mt={2}>
                        <TextField
                          variant='outlined'
                          fullWidth  
                          required
                          label="Descrição Especialidade"
                          error={error}
                          value={descricaoEspecialidade}
                          name="descricao_especialidade"
                          InputLabelProps={{
                            shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                          }}
                          onChange={(e) => {setDescricaoEspecialidade(e.target.value)}}
                        />
                      </MIUGrid>
                      <MIUGrid item xs={5} md={5} mt={2}>
                        <TextField
                          variant='outlined'
                          fullWidth  
                          required
                          label="Tipo de Recebimento"
                          error={error}
                          value={tipoRecebimento}
                          name="tipo_recebimento"
                          InputLabelProps={{
                            shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                          }}
                          onChange={(e) => {setTipoRecebimento(e.target.value)}}
                        />
                      </MIUGrid>
                    </MIUGrid>
                      {/* Vigencia */}
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ color: '#3f51b5', marginRight: '8px', marginBottom:'8px', marginTop: '8px', fontWeight: 800 }}>Vigência</span>
                        <Divider style={{ flex: 1 }} />
                      </div>
                      <MIUGrid container justifyContent="space-between">
                        <MIUGrid item xs={4} md={4} mt={2}>
                          <TextField
                            variant='outlined'
                            required
                            fullWidth 
                            type="date"  
                            label="Início"
                            value={inicio}
                            name="inicio"
                            InputLabelProps={{
                              shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                            }}
                            onChange={(e) => {setInicio(e.target.value)}}
                          />
                        </MIUGrid>
                        <MIUGrid item xs={4} md={4} mt={2}>
                          <TextField
                            variant='outlined'
                            fullWidth 
                            type="date"
                            label="Fim"
                            value={fim}
                            name="fim"
                            InputLabelProps={{
                              shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                            }}
                            onChange={(e) => {setFim(e.target.value)}}
                          />
                        </MIUGrid>
                        <MIUGrid item xs={4} md={4} mt={2}>
                          <TextField
                            variant='outlined'
                            required
                            fullWidth
                            type="number"  
                            label="Ticket Médio"
                            value={ticketMedio}                
                            name="ticket_medio"
                            InputLabelProps={{
                              shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">{'R$'}</InputAdornment>
                              ),
                            }}
                            onChange={(e) => {setTicketMedio(e.target.value)}}
                          />
                        </MIUGrid>
                      </MIUGrid>
                      


                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    
                    <Button onClick={handleCloseCreate}  color="primary">
                      Fechar
                    </Button>
                    <Button 
                      style={{marginRight:16}} 
                      onClick={ commitNovoTicketMedio } 
                      variant="contained" 
                      color="primary"
                      disabled={!descricaoEspecialidade || !tipoRecebimento || !ticketMedio || !inicio }
                    >
                      Salvar
                    </Button>
                  </DialogActions>
                  </Dialog>
                  
                  {/* Confirm Delete */}
                  <Dialog 
                    open={openDelete} 
                    onClose={handleCloseDelete} 
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                          width: '500px', 
                          margin: '0 auto'
                        },
                    }}
                  >
                    <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
                      <span style={{ display: 'inline-block', width: '100%' }}>
                        Você está prestes a deletar um item <b>PERMANENTEMENTE</b>!
                      </span>
                      <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleCloseDelete}
                        aria-label="close"
                        style={{
                          position: 'absolute',
                          right: 30,
                          top: 20,
                          padding: 0
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <Divider variant="fullWidth" />
                    <DialogContent >
                      <DialogContentText style={{ display: "flex", color: "black", alignItems:'center', alignContent: 'center' }}>
                        <div style={{ display: "flex", flexGrow: 1, justifyContent: "center" }}>
                          Ao prosseguir, não será mais possível ativá-lo novamente, deseja continuar?
                        </div>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                      <div style={{ marginLeft: 16, display: "flex", flexGrow: 1, justifyContent: "flex-start" }}>
                      <Button 
                        onClick={handleCloseDelete} 
                        variant="contained" 
                        color="default">
                          Cancelar
                        </Button>
                      </div>
                      <div style={{ display: "flex", flexGrow: 1, justifyContent: "flex-end" }}>
                        
                        <Button 
                          style={{ marginRight: 16 }} 
                          onClick={commitDelete} 
                          variant="contained" 
                          color="secondary"
                        >
                          Confirmar
                        </Button>
                      </div>
                    </DialogActions>
                  </Dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
